// Refer to localization docs for more information https://sandpit-app.safetyculture.com/storybook/sc-web-ui/index.html?path=/docs/documentation-development-guidelines--docs#localisation
const localization = {
    locale: () => "en-US",
    avatarGroup: {
        userCountTitle: (userNames, userOtherCount) => userOtherCount > 0
            ? `${userNames}, and ${userOtherCount} others.`
            : userNames,
    },
    filterGroup: {
        newFeature: () => "NEW",
    },
    timeline: {
        showMore: () => "Show more",
        showLess: () => "Show less",
        loadMore: () => "View more",
    },
    button: {
        remove: () => "Remove",
        done: () => "Done",
        addFilter: () => "Add filter",
        viewMore: () => "View more",
        clearAll: () => "Clear all",
    },
    card: {
        actionsLayout: {
            labelCountTitle: (labels, labelsOtherCount) => labelsOtherCount > 0
                ? labelsOtherCount > 0
                    ? `${labels}, +${labelsOtherCount}`
                    : labels
                : labels,
        },
    },
    carousel: {
        title: () => "carousel",
        gallery: () => "gallery",
        slide: () => "slide",
        showNext: () => "show next",
        showPrev: () => "show previous",
    },
    pagination: {
        nextPage: () => "Go to next page",
        previousPage: () => "Go to previous page",
        lastPage: () => "Go to last page",
        inputLabel: (max) => `Page number, of ${max} pages; Required`,
    },
    uploader: {
        dragHere: () => "Drag your file here",
        tryAgain: () => "Try again or",
        browse: () => "Browse",
        emptyFile: () => "File is empty.",
        fileTooLarge: () => "File is too large.",
        or: () => "or",
        uploading: () => "Uploading...",
        dropFileHere: () => "Drop your file here",
        invalidFileType: () => "Unsupported file type. Please check your file type and try again.",
        tooManyFiles: (maxCount) => `Too many files, only ${maxCount === 1 ? "one file is" : maxCount + " files are"} allowed.`,
    },
    hierarchicalPicker: {
        loadMore: () => "Load more",
    },
    formLabel: {
        optionalLabelDefault: () => "(optional)",
        requiredLabelDefault: () => "(required)",
    },
    typeLabel: {
        inspection: () => "Inspection",
        action: () => "Action",
        issue: () => "Issue",
        course: () => "Course",
        headsUp: () => "Heads Up",
        rapidRefresh: () => "Rapid Refresh",
        playlist: () => "Playlist",
        brainBoost: () => "Brain Boost",
        courseCollection: () => "Course Collection",
    },
    priorityLabel: {
        high: () => "High",
        medium: () => "Medium",
        low: () => "Low",
        none: () => "None",
    },
    searchInput: {
        search: () => "Search",
        clear: () => "Clear Search",
    },
    statusLabel: {
        "in-progress": () => "In Progress",
        completed: () => "Completed",
        open: () => "Open",
        resolved: () => "Resolved",
        "to-view": () => "To View",
        acknowledged: () => "Acknowledged",
        unacknowledged: () => "Unacknowledged",
    },
    layouts: {
        courseLayout: {
            lessons: (numberOfLessons) => numberOfLessons === 1 ? "1 Lesson" : `${numberOfLessons} Lessons`,
            lessonsTooltip: () => "Lessons",
        },
        rapidRefreshLayout: {
            sessions: (currentSession, totalSession) => `${currentSession} of ${totalSession}`,
            questions: (numberOfQuestions) => numberOfQuestions === 1
                ? "1 Question"
                : `${numberOfQuestions} Questions`,
        },
        brainBoostLayout: {
            questions: (numberOfQuestions) => numberOfQuestions === 1
                ? "1 Question"
                : `${numberOfQuestions} Questions`,
            duration: (duration) => duration === 1 ? "1 Minute" : `${duration} Minutes`,
        },
        playlistLayout: {
            courses: (numberOfCourses) => numberOfCourses === 1 ? "1 Course" : `${numberOfCourses} Courses`,
        },
        inductionsLayout: {
            steps: (numberOfSteps) => numberOfSteps === 1 ? "1 Step" : `${numberOfSteps} Steps`,
        },
    },
    passwordInput: {
        showPassword: () => "Show password as plain text.",
        hidePassword: () => "Hide password",
    },
    modal: {
        closeButton: () => "Close button",
    },
    inputTag: {
        defaultLabel: () => "Tag",
    },
    catalogLayout: {
        titleImageAlt: (title) => `Image for ${title}`,
    },
    select: {
        placeholder: () => "Select",
        inputTriggerButtonAriaLabel: () => "Open dropdown",
        dropdownContentAriaLabel: () => "Dropdown content",
        noResultsFound: () => "No results found",
        addItemButtonText: (value) => `Add ‘${value}’`,
    },
    datePicker: {
        parseFailed: () => "Date is not valid",
        minExceeded: (minDate) => `Date should be after ${minDate}`,
        maxExceeded: (maxDate) => `Date should be before ${maxDate}`,
        disabledDate: () => "Date is disabled",
        requiredDate: () => "Date is required",
    },
    dialogCloseButton: {
        closeBtn: () => "Close dialog",
    },
    table: {
        addEditableCellValue: () => "Add",
        sortButton: () => "Sort button",
    },
    notification: {
        regionLabel: () => "Notifications",
    },
};
export default localization;
